module.exports = __webpack_public_path__ + "static/media/Lato-BlackItalic.2e26a916.ttf";